<template>
  <div class="a4-page">
    <spacer :y="3"/>
    <div :class="$style.wrapper">
      <div v-if="user">
        <h1 :class="$style.c">【Welcome to talk アカウント登録】</h1>
        <spacer :y="2"/>
        <p>{{ user.username }} 様（{{ user.school_year }}年）</p>
        <spacer :y="2"/>
        <p>１、以下の個別QRコードを読み取り登録フォームにアクセス。</p>
        <spacer :y="2"/>
        <p :class="$style.qr"><img :src="`https://api.qrserver.com/v1/create-qr-code//?size=120x120&data=${baseURL}/signup2/?customer=${user.id}%26school=${user.school[0].id}`"></p>
        <spacer :y="2"/>
        <p>２、画面に沿って基本情報を入力した後、「入力内容を確認する」をクリック、利用規約に同意のうえ、「入力内容を確定する」をクリックすると本登録が完了します。<br><span :class="$style.underline">【注意】基本情報の入力時に作成した“パスワード”は忘れないようにお控えください。</span></p>

        <spacer :y="4"/>
        <h2 :class="$style.c">【マイページへのログイン】</h2>
        <spacer :y="2"/>
        <p>アカウントの登録完了後、下記QRコードを読み取りログイン画面にアクセス。<br>登録メールアドレスとパスワードを入力してログインしてください。</p>
        <spacer :y="2"/>
        <div :class="$style.flex">
          <p :class="$style.qr"><img :src="`https://api.qrserver.com/v1/create-qr-code//?size=120x120&data=${baseURL}/login/`"></p>
          <p :class="$style.b">登録メールアドレス:{{ user.email }}</p>
        </div>
        <spacer :y="2"/>
        <ul :class="$style.lists">
          <li>メールアドレス（ID）はマイページの設定画面にて変更が可能です。閲覧可能なメールアドレスにご変更ください。</li>
          <li>マイページからLINE連携も可。予約完了時など自動通知が届きます。ぜひご活用ください。</li>
          <li>後日、パスワードを忘れた場合はログイン画面の「パスワードをお忘れですか?」より登録メールアドレスをご入力ください。登録メールアドレス宛にパスワード再設定手続きのメールが届きます。</li>
        </ul>
        <spacer :y="4"/>
        <div :class="[$style.c, $style.bdr]">
          <p>**個人情報のお取り扱いについて**</p>
          <p>本資料には、みなさまの個人情報が含まれます。<br>つきましては、以下の点にご留意いただき、適切なお取り扱いをお願いします。</p>
          <ul>
            <li>本資料の目的以外での利用はご遠慮ください。</li>
            <li>第三者への開示、漏洩、紛失等がないようご注意ください。</li>
            <li>本資料が不要になった際は、先生に返却するなど適切な方法で廃棄をお願いいたします。</li>
          </ul>
        </div>
      </div>
    </div>
    <spacer :y="1"/>
  </div>
</template>

<script>
import Spacer from '@/views/components/Spacer.vue';
import cf from '@/mixins/commonFunctions.js';

export default {
  name: 'print',
  mixins: [cf],
  components: {
    Spacer,
  },
  props: {
    user: {
      type: Object,
    },
  },
  data() {
    return {
    };
  },
  created() {
  },
  computed: {
    baseURL() {
      return `${location.protocol}//${location.host}`;
    },
  },
  methods: {
  },
};
</script>

<style lang="scss" module>
.wrapper {
  font-size: 13px;
  .c {
    text-align: center;
  }
  .underline {
    text-decoration: underline;
  }
  .b {
    font-weight: bold;
  }
  .flex {
    display: flex;
    align-items: center;
    > *:not(:first-child) {
      margin-left: 2em;
    }
  }
  .lists {
    li {
      position: relative;
      padding-left: 1em;
      &:before {
        content: '*';
        position: absolute;
        top: .3em;
        left: 0;
      }
    }
  }
  .bdr {
    padding: 1em;
    border: 3px solid #333;
    > *:not(:first-child) {
      margin-top: 1em;
    }
  }
}
</style>
